export const ActionTypes = {
  FETCH_JOB_OPERATORS_OPERATION: 'services/jobImportHistoryOperation/fetch_job_import_history_operators_operation',
  SET_JOB_IMPORT_HISTORY_DATA: 'services/jobImportHistoryOperation/set_job_import_history_operators_operation',
  DOWNLOAD_IMPORT_FILE_BY_FILE_NAME: 'services/jobImportHistoryOperation/download_import_file_by_file_name_operation',
  SET_DOWNLOAD_IMPORT_FILE_DATA_OPERATION: 'services/jobImportHistoryOperation/set_download_import_file_data_operation',
  CLEAR_DOWNLOAD_IMPORT_FILE_DATA: 'services/jobImportHistoryOperation/clear_download_import_file_data',
};

const fetchFileNameByFactoryId = ({ jobImportHistoryOperationParams }) => ({
  jobImportHistoryOperationParams,
  type: ActionTypes.FETCH_JOB_OPERATORS_OPERATION,
});

const setJobImportHistoryOperation = ({ jobImportHistoryOperationData }) => ({
  jobImportHistoryOperationData,
  type: ActionTypes.SET_JOB_IMPORT_HISTORY_DATA,
});

const downloadImportFileByFileName = ({ factoryid, fileName, isErp, id }) => ({
  factoryid,
  fileName,
  isErp,
  id,
  type: ActionTypes.DOWNLOAD_IMPORT_FILE_BY_FILE_NAME,
});

const clearDownloadImportFileData = () => ({
  type: ActionTypes.CLEAR_DOWNLOAD_IMPORT_FILE_DATA,
});

const setDownloadImportFileDataOperation = ({ downloadImportfileHistoryOperationData }) => ({
  downloadImportfileHistoryOperationData,
  type: ActionTypes.SET_DOWNLOAD_IMPORT_FILE_DATA_OPERATION,
});

export default {
  fetchFileNameByFactoryId,
  setJobImportHistoryOperation,
  downloadImportFileByFileName,
  setDownloadImportFileDataOperation,
  clearDownloadImportFileData,
};
